import { FieldLabel, TextFieldContainer } from "../styles/common.styles";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface Props {
	settings: Record<string, string | boolean | string[]>;
	setSettings: React.Dispatch<
		React.SetStateAction<Record<string, string | boolean | string[]>>
	>;
	label: string;
	slug: string;
	helper?: string;
}

const SettingsTextField = ({
	settings,
	setSettings,
	label,
	slug,
	helper,
}: Props) => {
	return (
		<TextFieldContainer>
			<Stack direction='row' spacing={1} alignItems='center'>
				<FieldLabel variant='subtitle2'>{label}</FieldLabel>
				{Boolean(helper) && (
					<Tooltip title={helper as string} placement='right'>
						<IconButton size='small'>
							<InfoOutlinedIcon fontSize='inherit' />
						</IconButton>
					</Tooltip>
				)}
			</Stack>
			{settings[slug] === undefined || (settings[slug] as string).length < 0 ? (
				<Skeleton variant='rectangular' width='70%'>
					<TextField />
				</Skeleton>
			) : (
				<TextField
					id={slug}
					name={slug}
					value={(settings[slug] as string) || ""}
					onChange={(e) => setSettings({ ...settings, [slug]: e.target.value })}
					sx={{ width: "70%" }}
				/>
			)}
		</TextFieldContainer>
	);
};

export default SettingsTextField;
